import { AssigneeEntity } from '@omnea-app/core/blocks'
import { CurrencyCode } from '@omnea-app/packages/universal/currency-utils/getCurrencyCodes'
import { DateFormatKey } from '@omnea-app/packages/universal/date-utils/dateFormat'
import { UserSyncConfig, defaultUserSyncConfig } from '@omnea-app/packages/universal/organisation-settings/userSyncConfigSchema'

export type OrganisationSettings = {
  budgetApprovalThresholdColumnsVisibility: {
    inBudget: boolean
    departments: boolean
  }
  defaultCurrency: { defaultCurrency: CurrencyCode }
  dateFormatPreference: { dateFormatPreference: DateFormatKey | null }
  externalDomains: string[]
  fallbackAssignee: AssigneeEntity[]
  hasSsoEnabled: boolean
  hasDirectorySyncEnabled: boolean
  hasScimEnabled: boolean
  hasScimGroupSyncEnabled: boolean
  managerEscalationEnabled: boolean
  archivedUserReassignmentEnabled: boolean
  archivedUserNotifyAssignees: AssigneeEntity[]
  postEscalationRemindersEnabled: boolean
  nonConfigAdminRollbackEnabled: boolean
  userSyncConfig: UserSyncConfig
}

export const DEFAULT_CURRENCY: CurrencyCode = 'USD'

export const defaultSettings: OrganisationSettings = {
  budgetApprovalThresholdColumnsVisibility: {
    inBudget: false,
    departments: false,
  },
  defaultCurrency: { defaultCurrency: DEFAULT_CURRENCY },
  dateFormatPreference: { dateFormatPreference: null },
  fallbackAssignee: [],
  externalDomains: [],
  hasSsoEnabled: false,
  hasDirectorySyncEnabled: false,
  hasScimEnabled: false,
  hasScimGroupSyncEnabled: false,
  managerEscalationEnabled: false,
  archivedUserReassignmentEnabled: false,
  archivedUserNotifyAssignees: [],
  postEscalationRemindersEnabled: false,
  nonConfigAdminRollbackEnabled: false,
  userSyncConfig: defaultUserSyncConfig,
} as const
